module.exports = __webpack_public_path__ + "static/media/projects.fivethirtyeight.com_senate-2016_plot.6c217343.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/projects.fivethirtyeight.com_senate-2016_plot.png
// module id = 420
// module chunks = 0